const originalPrefix = '_orig_'

export class I18NTranslated {
    i18n: { ['lang']: string, [prop: string]: string }
}

/**
 * Applies the translation to the i18n properties
 * @param target An array of {@link I18NTranslated} on which translations will be applied.
 */
export function applyTranslations<T extends I18NTranslated>(target: T[]): T[] {
    return target.map((incoming: T) => {
        if(!incoming.i18n)
            return incoming
        
        let props = Object.keys(incoming.i18n)
            .filter(p => p !== 'lang')
        if(props.length === 0)
            return incoming

        let translateable = Object.assign({}, incoming)
        let i18n = translateable.i18n

        props.forEach(prop => {
            let translation = i18n[prop]
            let initial = translateable[prop]

            Object.assign(
                translateable,
                {
                    [originalPrefix + prop]: initial,
                    [prop]: translation || initial
                }
            )
        })

        return translateable
    })
}